// Field names
export const F_01 = "FIELD_01";
export const F_02 = "FIELD_02";
export const F_03 = "FIELD_03";
export const F_04 = "FIELD_04";
export const F_05 = "FIELD_05";
export const F_06 = "FIELD_06";

export const fieldNames = [F_01, F_02, F_03, F_04, F_05, F_06];
